"use strict";

exports.__esModule = true;
exports.ModalProvider = exports.ModalContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useModalState2 = _interopRequireDefault(require("../../../shared/hooks/useModalState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ModalContext = (0, _react.createContext)({});
exports.ModalContext = ModalContext;

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children,
      onToggle = _ref.onToggle;

  var _useModalState = (0, _useModalState2["default"])({
    onToggle: onToggle
  }),
      open = _useModalState.open,
      openUI = _useModalState.openModal,
      closeUI = _useModalState.closeModal;

  var data = {
    open: open,
    openUI: openUI,
    closeUI: closeUI
  };
  return /*#__PURE__*/_react["default"].createElement(ModalContext.Provider, {
    value: data
  }, children);
};

exports.ModalProvider = ModalProvider;
ModalProvider.propTypes = {
  /** function callback when modal is opened or closed */
  onToggle: _propTypes["default"].func
};
ModalProvider.defaultProps = {
  onToggle: null
};